module.exports = __webpack_public_path__ + "img/1d-s17.c68dcf55.gif";